const e = {
  getV1OwnertypeOwneridLimitTypes: {
    schema: {
      method: "get",
      url: "/v1/{ownerType}/{ownerId}/limit-types"
    }
  },
  getV1OwnertypeOwneridMonetary: {
    schema: {
      method: "get",
      url: "/v1/{ownerType}/{ownerId}/monetary"
    }
  },
  getV1DepositLimits: {
    schema: {
      method: "get",
      url: "/v1/deposit-limits"
    }
  },
  postV1DepositLimits: {
    schema: {
      method: "post",
      url: "/v1/deposit-limits",
      mediaType: "application/vnd.api+json"
    }
  },
  getV1DepositLimitsId: {
    schema: {
      method: "get",
      url: "/v1/deposit-limits/{id}"
    }
  },
  deleteV1DepositLimitsId: {
    schema: {
      method: "delete",
      url: "/v1/deposit-limits/{id}"
    }
  }
};
export {
  e as v1Service
};
